import { BehaviorSubject, Observable } from "rxjs";

export class ParamsSubjectBuilder<T> {
  #subject$: BehaviorSubject<T>;
  #value: T;

  constructor(initialValue: T) {
    this.#subject$ = new BehaviorSubject<T>(initialValue);
    this.#value = { ...initialValue };
  }

  asObservable(): Observable<T> {
    return this.#subject$.asObservable();
  }

  set<K extends keyof T>(key: K, value: Partial<T[K]>): this {
    this.#value = {
      ...this.#value,
      [key]: {
        ...this.#value[key],
        ...value
      }
    };

    return this;
  }

  update(updatedFields: Partial<T>): this {
    for (const key in updatedFields) {
      if (updatedFields.hasOwnProperty(key)) {
        this.#value[key] = {
          ...this.#value[key],
          ...updatedFields[key]
        };
      }
    }

    return this;
  }

  apply(): void {
    this.#subject$.next({ ...this.#value });
  }
}
